import {React, useEffect} from 'react';

import AemEditableText from '@/components/Aem/AemEditableText/AemEditableText';
import {DeliveryItemsIcon} from '@/components/Icons';
import {InlineNotification} from '@/components/ui/InlineNotification';
import appConfig from '@/config/appConfig.typed';
import {AUTO_DELIVERY_SKIP_CANT_BE_SKIPPER_BUTTON_ARIA_LABEL} from '@/consts/localization/localizationKeys';
import routePaths from '@/consts/route/routePaths';
import amplitudeAutoDeliveryTracking from '@/services/analytics/amplitude/amplitudeAutoDeliveryTracking';
import googleAnalyticsService from '@/services/analytics/ga/googleAnalyticsService';
import AutoDeliveryButton from '@/views/AutoDelivery/AutoDeliveryButton';
import AutoDeliveryStatusTitle from '@/views/AutoDelivery/AutoDeliveryStatusTitle';

import useDeliveryDate from '../hooks/useDeliveryDate';
import useOrderSummaryTracking from '../hooks/useOrderSummaryTracking';
import EditDeliveryPopupTopSection from './EditDeliveryPopupTopSection';

const DeliverySkipSection = () => {
    const externalLinkConfig = appConfig.getAutoDeliverySkipGoToWebsiteExternalLink();
    const {skipDateShort, isSkipDeliveryAvailable} = useDeliveryDate();
    const orderSummaryTrackingValue = useOrderSummaryTracking();

    useEffect(() => {
        if (!isSkipDeliveryAvailable) {
            amplitudeAutoDeliveryTracking.trackAutoDeliverySkipDeliveryNotAvailable(orderSummaryTrackingValue);
            googleAnalyticsService.trackAutoDeliverySkipDeliveryNotAvailable(orderSummaryTrackingValue);
        }
    }, [isSkipDeliveryAvailable]);

    return isSkipDeliveryAvailable ? (
        <EditDeliveryPopupTopSection
            header={<AemEditableText pageName={routePaths.AUTO_DELIVERY} itemName='skipDeliveryConfirmHeaderTitle' />}
            title={<AemEditableText pageName={routePaths.AUTO_DELIVERY} itemName='skipDeliveryConfirmTitle' />}
            subtitle={
                <AemEditableText
                    pageName={routePaths.AUTO_DELIVERY}
                    itemName='skipDeliveryConfirmSubTitle'
                    contentList={[skipDateShort]}
                />
            }
            infoText={<AemEditableText pageName={routePaths.AUTO_DELIVERY} itemName='skipDeliveryConfirmDescription' />}
            icon={<DeliveryItemsIcon />}
        />
    ) : (
        <div className='pb-8 md:pb-0'>
            <AutoDeliveryStatusTitle
                title={
                    <AemEditableText pageName={routePaths.AUTO_DELIVERY} itemName='skipDeliveryConfirmHeaderTitle' />
                }
                className='text-28'
            />
            <InlineNotification
                title={
                    <AemEditableText pageName={routePaths.AUTO_DELIVERY} itemName='skipDeliveryCantBeSkippedTitle' />
                }
                body={
                    <AemEditableText
                        pageName={routePaths.AUTO_DELIVERY}
                        itemName='skipDeliveryCantBeSkippedDescription'
                    />
                }
            >
                <AutoDeliveryButton
                    primary
                    light
                    className='mt-0'
                    text={
                        <AemEditableText
                            pageName={routePaths.AUTO_DELIVERY}
                            itemName='skipDeliveryCantBeSkippedButton'
                        />
                    }
                    externalLinkConfig={externalLinkConfig}
                    ariaLabelKey={AUTO_DELIVERY_SKIP_CANT_BE_SKIPPER_BUTTON_ARIA_LABEL}
                />
            </InlineNotification>
        </div>
    );
};

export default DeliverySkipSection;
